'use client'

import { useEffect } from 'react'

export function SectionObserver(): null {
  useEffect(() => {
    const sections = document.querySelectorAll('section, header, footer')
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          entry.target.classList.toggle('in-view', entry.isIntersecting)
        }
      },
      { rootMargin: '200px 0px' }
    )
    for (const section of sections) observer.observe(section)
    return () => observer.disconnect()
  }, [])

  return null
}
